if (!customElements.get('nutra-card-variant')) {
  customElements.define(
    'nutra-card-variant',
    class NutraCardVariant extends HTMLElement {
      constructor() {
        super();
        this.onOptionClick = this.handleOptionClick.bind(this);
        this.onPointerDown = this.handlePointerDown.bind(this);
      }

      connectedCallback() {
        this.card = this.closest('.nutra-product-card');
        this.label = this.querySelector('[data-nutra-variant-label]');
        this.options = Array.from(this.querySelectorAll('[data-variant-id]'));
        this.image = this.card?.querySelector('[data-nutra-card-image]');
        this.links = Array.from(this.card?.querySelectorAll('[data-nutra-card-link]') || []);
        this.variantInput = this.card?.querySelector('.product-variant-id');
        this.addButton = this.card?.querySelector('[name="add"]');
        this.addButtonText = this.addButton?.querySelector('span');
        this.price = this.card?.querySelector('.nutra-product-card__price');
        this.heading = this.card?.querySelector('[data-nutra-card-title]');

        this.options.forEach((option) => {
          option.addEventListener('pointerdown', this.onPointerDown);
          option.addEventListener('click', this.onOptionClick);
        });
      }

      disconnectedCallback() {
        this.options.forEach((option) => {
          option.removeEventListener('pointerdown', this.onPointerDown);
          option.removeEventListener('click', this.onOptionClick);
        });
      }

      handlePointerDown(event) {
        if (event.pointerType === 'mouse' || event.pointerType === 'touch' || event.pointerType === 'pen') {
          event.preventDefault();
        }
      }

      handleOptionClick(event) {
        event.preventDefault();
        event.stopPropagation();
        this.select(event.currentTarget);
        this.releaseFocus();
        requestAnimationFrame(() => this.releaseFocus());
      }

      releaseFocus() {
        const active = document.activeElement;
        if (active && this.card?.contains(active) && typeof active.blur === 'function') {
          active.blur();
        }
      }

      select(option) {
        const variantId = option.getAttribute('data-variant-id');
        const label = option.getAttribute('data-label') || option.textContent.trim();
        const image = option.getAttribute('data-image');
        const imageAlt = option.getAttribute('data-image-alt') || label;
        const url = option.getAttribute('data-variant-url');
        const price = option.getAttribute('data-price');
        const available = option.getAttribute('data-available') === 'true';
        const titleNode = option.querySelector('[data-nutra-option-title]');
        const title = titleNode?.textContent?.trim();

        if (this.label) this.label.textContent = label;
        if (this.heading && title) this.heading.textContent = title;

        if (this.image && image) {
          this.image.src = image;
          this.image.alt = imageAlt;
        }

        this.links.forEach((link) => {
          if (url) link.setAttribute('href', url);
        });

        if (this.price && price) this.price.textContent = price;

        if (this.variantInput && variantId) {
          this.variantInput.disabled = false;
          this.variantInput.value = variantId;
        }

        if (this.addButton) {
          this.addButton.disabled = !available;
          if (this.addButtonText) {
            this.addButtonText.textContent = available
              ? window.variantStrings?.addToCart || this.addButtonText.textContent
              : window.variantStrings?.soldOut || this.addButtonText.textContent;
          }
        }

        this.options.forEach((item) => {
          item.setAttribute('aria-pressed', item === option ? 'true' : 'false');
        });
      }
    }
  );
}
